export default function TOU() {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 39C30.4934 39 39 30.4934 39 20C39 9.50659 30.4934 1 20 1C9.50659 1 1 9.50659 1 20C1 30.4934 9.50659 39 20 39Z" fill="#396FE5" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21 10H19L19.5 18H20.5L21 10ZM20.5 22H19.5L19 30H21L20.5 22ZM30 19V21L22 20.5V19.5L30 19ZM18 20.5V19.5L10 19V21L18 20.5ZM15.866 10.8398L14.134 11.8398L18.567 18.518L19.433 18.018L15.866 10.8398ZM21.433 21.4821L20.567 21.9821L24.134 29.1604L25.866 28.1604L21.433 21.4821ZM28.1602 14.1341L29.1602 15.8661L21.982 19.4331L21.482 18.5671L28.1602 14.1341ZM18.5179 21.4331L18.0179 20.5671L10.8397 24.1341L11.8397 25.8661L18.5179 21.4331ZM10.8397 15.8659L11.8397 14.1339L18.5179 18.5669L18.0179 19.4329L10.8397 15.8659ZM21.482 21.4329L21.982 20.5669L29.1602 24.1339L28.1602 25.8659L21.482 21.4329ZM25.866 11.8396L24.134 10.8396L20.567 18.0179L21.433 18.5179L25.866 11.8396ZM18.567 21.482L19.433 21.982L15.866 29.1602L14.134 28.1602L18.567 21.482Z"
                fill="url(#paint0_radial_3955_10927)"
            />
            <defs>
                <radialGradient
                    id="paint0_radial_3955_10927"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(20 20) rotate(-20.2249) scale(10.1242)"
                >
                    <stop stopColor="#396FE5" />
                    <stop offset="0.557292" stopColor="white" />
                    <stop offset="1" stopColor="white" />
                </radialGradient>
            </defs>
        </svg>
    );
}
